import { render } from "./SelectFormSubcourse.vue?vue&type=template&id=4b8aaaa0&scoped=true"
import script from "./SelectFormSubcourse.vue?vue&type=script&lang=js"
export * from "./SelectFormSubcourse.vue?vue&type=script&lang=js"

import "./SelectFormSubcourse.vue?vue&type=style&index=0&id=4b8aaaa0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vue-soft/vue-soft/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b8aaaa0"]])

export default __exports__